<!-- Dashboard 901M Component - Angular 12 Migration -->
<!-- Obsługuje wiele widoków: calculationReason, comments, adjustmentScreen, uploadAttachment, postAdj -->

<!-- ==================== CALCULATION REASON VIEW ==================== -->
@if (viewType === 'calculationReason') {

  <!-- Modal Header -->
  <div class="modal-header">
    <h3 class="modal-title">{{title}}</h3>
    <div class="header-actions">
      <i class="fa" 
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
         style="margin-right: 10px; cursor: pointer;" 
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <!-- Modal Body -->
  <div class="modal-body" [hidden]="minimise">
    <form name="calculation901ReasonForm" id="calculation901ReasonForm" novalidate autocomplete="off">
      
      <!-- Loader -->
      @if (showFormLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      @if (!showFormLoader) {
<div>
        <!-- 901(m) Calculation Required - Radio Buttons -->
        <div class="row form-group">
          <label class="col-md-6">901(m) Calculation Required</label>
          <div class="col-md-6">
            <div class="row">
              <div class="radioBtnPosition col-md-4">
                Yes 
                <input type="radio" 
                       style="margin-left: 5px" 
                       [value]="'Y'" 
                       [checked]="Review === 'Y'"
                       (change)="onRadioChange('Y')" 
                       class="radio"
                       name="review_radio">
              </div>
              <div class="radioBtnPosition col-md-4">
                No 
                <input type="radio" 
                       style="margin-left: 5px" 
                       [value]="'N'" 
                       [checked]="Review === 'N'"
                       (change)="onRadioChange('N')" 
                       class="radio"
                       name="review_radio">
              </div>
            </div>
          </div>
        </div>

        <!-- Comments -->
        <div class="row">
          <div class="form-group">
            <label class="col-md-1 control-label"><strong>Comments:</strong></label>
            <div class="col-md-6">
              <textarea class="form-control" 
                        name="comments" 
                        [(ngModel)]="COMMENTS" 
                        maxlength="3998"></textarea>
              <div class="textarea_allowed">Max 2000</div>
            </div>
          </div>
        </div>

        <!-- Comments Table -->
        <div class="row row-mt-10">
          <div class="col-md-12">
            <table class="table table-bordered custom-table" style="text-align: left; table-layout: fixed;">
              <thead>
                <tr>
                  <th width="70%">Comment</th>
                  <th width="15%">Logged By</th>
                  <th width="15%">Logged On</th>
                </tr>
              </thead>
              <tbody>
                @for (comment of allComments; track trackByIndex($index, comment)) {
<tr>
                  <td style="word-wrap: break-word">{{comment.DETAIL_COMMENTS}}</td>
                  <td>{{comment.UPDATED_BY}}</td>
                  <td>{{comment.UPDATED_ON}}</td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
}
    </form>
  </div>

  <!-- Modal Footer -->
  <div class="modal-footer" [hidden]="minimise">
    <button class="save-button" 
            type="button" 
            [disabled]="isSaveClicked" 
            (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
    </button>
    <button class="cancel-button" 
            type="button" 
            (click)="cancel()">Cancel</button>
  </div>

}

<!-- ==================== COMMENTS ONLY VIEW ==================== -->
@if (viewType === 'comments') {

  <!-- Modal Header -->
  <div class="modal-header">
    <h3 class="modal-title">{{title}}</h3>
    <div class="header-actions">
      <i class="fa" 
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
         style="margin-right: 10px; cursor: pointer;" 
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <!-- Modal Body -->
  <div class="modal-body" [hidden]="minimise">
    <form name="calculation901ReasonForm" novalidate autocomplete="off">
      
      <!-- Loader -->
      @if (showFormLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      @if (!showFormLoader) {
<div>
        <!-- Comments (bez radio buttons) -->
        <div class="row">
          <div class="form-group">
            <label class="col-md-1 control-label"><strong>Comments:</strong></label>
            <div class="col-md-6">
              <textarea class="form-control" 
                        name="comments" 
                        [(ngModel)]="COMMENTS" 
                        maxlength="3998"></textarea>
              <div class="textarea_allowed">Max 2000</div>
            </div>
          </div>
        </div>

        <!-- Comments Table -->
        <div class="row row-mt-10">
          <div class="col-md-12">
            <table class="table table-bordered custom-table" style="text-align: left; table-layout: fixed;">
              <thead>
                <tr>
                  <th width="70%">Comment</th>
                  <th width="15%">Logged By</th>
                  <th width="15%">Logged On</th>
                </tr>
              </thead>
              <tbody>
                @for (comment of allComments; track trackByIndex($index, comment)) {
<tr>
                  <td style="word-wrap: break-word">{{comment.DETAIL_COMMENTS}}</td>
                  <td>{{comment.UPDATED_BY}}</td>
                  <td>{{comment.UPDATED_ON}}</td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
}
    </form>
  </div>

  <!-- Modal Footer -->
  <div class="modal-footer" [hidden]="minimise">
    <button class="save-button" 
            type="button" 
            [disabled]="isSaveClicked" 
            (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
    </button>
    <button class="cancel-button" 
            type="button" 
            (click)="cancel()">Cancel</button>
  </div>

}

<!-- ==================== ADJUSTMENT SCREEN VIEW ==================== -->
@if (viewType === 'adjustmentScreen') {

  <!-- Modal Body (bez header w oryginalnym) -->
  <div class="modal-body no-body-scroll">
    <form name="adjustmentScreen" novalidate autocomplete="off">
      
      <!-- Loader -->
      @if (showFormLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      @if (!showFormLoader) {
<div>
        <!-- Info text -->
        <div>
          <i class="fa fa-info-circle" aria-hidden="true"></i>&nbsp;
          <strong>After you verify the basis difference and estimated foreign taxable income, click on Save Changes to post
            a double sided E&P adjustment for all entities with an amount in the Disqualified Tax Adjustment column.</strong>
        </div>
        <br>

        <!-- Adjustment Table -->
        <div class="table-responsive">
          <table class="gt-reclass-table table table-bordered table-striped table-condensed custom-table">
            <thead>
              <tr>
                <th>User Signed Off</th>
                <th>Date Signed Off</th>
                <th>EntityDetails</th>
                <th>Country/Business</th>
                <th>Currency</th>
                <th>US Tax Type</th>
                <th>Basis Difference Per FIR</th>
                <th>Adjustment to Basis</th>
                <th>Adjusted Basis Difference</th>
                <th>Adjusted Basis Income/(Loss)</th>
                <th>Adjustment to Estimated Foreign Taxable Income</th>
                <th>Adjusted Foreign Taxable Income</th>
                <th>E&P Current Tax Provision before 901(m)</th>
                <th>Taxes Not Subject to 901(m)</th>
                <th>Taxes Subject to 901(m)</th>
                <th>Disqualified %</th>
                <th>Disqualified Tax Adjustment</th>
                <th>E&P Current Tax Provision after 901(m)</th>
                <th>Current 901(m) Balance</th>
                <th>Comments</th>
                <th>Supporting Document</th>
              </tr>
            </thead>
            <tbody>
              <!-- Parent rows (gray background) -->
              @for (field of adjustmentParentArray; track trackByIndex($index, field)) {
<tr class="bg-color-gray">
                <td>{{field.SIGNOFF_Y_N}}</td>
                <td>{{field.SIGNOFF_ON}}</td>
                <td>{{field.LE_ENTITY_DETAILS}}</td>
                <td>{{field.LEID}}</td>
                <td>{{field.FUNC_CURR}}</td>
                <td>{{field.LE_TAX_TYPE}}</td>
                <td class="text-right">{{field.CONVERTED_EP_AMT | number}}</td>
                <td class="text-right">{{field.CONVERTED_BASIS_AMT | number}}</td>
                <td class="text-right">{{field.adjBasisDiff | number}}</td>
                <td class="text-right">{{field.CONVERTED_TB_AMT | number}}</td>
                <td class="text-right">{{field.CONVERTED_FTI_AMT | number}}</td>
                <td class="text-right">{{field.adjForeignTaxIncome | number}}</td>
                <td class="text-right">{{field.CONVERTED_EP_BEFORE901_AMT | number}}</td>
                <td class="text-right">{{field.CONVERTED_N901_AMT | number}}</td>
                <td class="text-right">{{field.taxSubj901 | number}}</td>
                <td class="text-right">{{field.DisqualifiedTotPct | number}}</td>
                <td class="text-right">{{field.disQualifiedTax | number}}</td>
                <td class="text-right">{{field.epcurTaxProv | number}}</td>
                <td class="text-right">{{field.CONVERTED_EP_TAX_AMT | number}}</td>
                <td></td>
                <td></td>
              </tr>
}

              <!-- Child rows (editable) -->
              @for (field of adjustmentChildArray; track trackByIndex(i, field); let i = $index) {
<tr>
                <td>
                  <input type="checkbox"
                         [checked]="field.SIGNOFF_Y_N === 'Y'"
                         (change)="field.SIGNOFF_Y_N = $any($event.target).checked ? 'Y' : 'N'">
                </td>
                <td>{{field.SIGNOFF_ON}}</td>
                <td>{{field.LE_ENTITY_DETAILS}}</td>
                <td>{{field.LEID}}</td>
                <td>{{field.REPORTING_CURR}}</td>
                <td>{{field.LE_TAX_TYPE}}</td>
                <td class="text-right">{{field.EP_AMT | number}}</td>
                <td>
                  <input type="number" 
                         class="form-control text-right" 
                         [(ngModel)]="field.BASIS_AMT" 
                         [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="calcAdjBasis(field)">
                </td>
                <td class="text-right">{{field.CONVERTED_BASIS_AMT | number}}</td>
                <td class="text-right">{{field.TB_AMT | number}}</td>
                <td>
                  <input type="number" 
                         class="form-control text-right" 
                         [(ngModel)]="field.FTI_AMT" 
                         [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="calFTIAmount(field)">
                </td>
                <td class="text-right">{{field.CONVERTED_FTI_AMT | number}}</td>
                <td class="text-right">{{field.EP_BEFORE901_AMT | number}}</td>
                <td>
                  <input type="number" 
                         class="form-control text-right" 
                         [(ngModel)]="field.N901_AMT" 
                         [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="calN901Amount(field)">
                </td>
                <td class="text-right">{{field.CONVERTED_N901_AMT | number}}</td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{field.CONVERTED_EP_TAX_AMT}}</td>
                <td>
                  <i style="font-size:18px;cursor: pointer;" 
                     title="Add Comment" 
                     class="fa fa-comment-o pull-right" 
                     (click)="addComment(field)"></i>
                </td>
                <td>
                  <i style="font-size:18px;cursor: pointer;" 
                     title="Add Attachment" 
                     class="fa fa-paperclip pull-right" 
                     (click)="addAttachment(field)"></i>
                </td>
              </tr>
}
            </tbody>
          </table>
        </div>
      </div>
}
    </form>
  </div>

  <!-- Modal Footer -->
  <div class="modal-footer">
    <button class="save-button" 
            type="button" 
            [disabled]="isSaveClicked" 
            (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
    </button>
    <button class="reset-button" 
            type="button" 
            (click)="reset()">Reset Form</button>
    <button class="cancel-button" 
            type="button" 
            (click)="cancel()">Cancel</button>
  </div>

}

<!-- ==================== UPLOAD ATTACHMENT VIEW ==================== -->
@if (viewType === 'uploadAttachment') {

  <!-- Modal Header -->
  <div class="modal-header">
    <h3 class="modal-title">Upload Attachment</h3>
    <div class="header-actions">
      <i class="fa" 
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
         style="margin-right: 10px; cursor: pointer;" 
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <!-- Modal Body -->
  <div class="modal-body no-body-scroll" [hidden]="minimise">
    <form name="attachmentForm" novalidate autocomplete="off">
      <div class="row">
        <div class="col-md-2"><strong>Legal Entity ID</strong></div>
        <div class="col-md-6">{{rowData.LEID}}</div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-2"><strong>BSLA CODE</strong></div>
        <div class="col-md-6">{{rowData.ME_CODE}}</div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-2"><strong>CDR</strong></div>
        <div class="col-md-6">{{rowData.CDR_NO}}</div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-2"><strong>Tax Year</strong></div>
        <div class="col-md-6">{{rowData.TAX_YEAR}}</div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-2"><strong>Support Type</strong></div>
        <div class="col-md-6">Supporting Documentation</div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-2"><strong>Legal Entity Details</strong></div>
        <div class="col-md-6">{{rowData.LE_ENTITY_DETAILS}}</div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-2"><strong>Scenario</strong></div>
        <div class="col-md-6">{{rowData.SCENARIO}}</div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-2"><strong>Description</strong></div>
        <div class="col-md-6">
          <textarea placeholder="add Description" rows="3" class="form-control"></textarea>
        </div>
      </div>
      <br>
      
      <!-- File upload area - placeholder (wymaga integracji z systemem plików) -->
      @if (!showFormLoader) {
<div class="row">
        <div class="col-sm-12">
          <label for="notify">Attachments
            @if (attachmentTO.isError) {
<span class="form-error-container" style="background-color:orange">
              Upload failed: <b style="color:green">Allowed Extensions: jpg, jpeg, png, svg, pdf, xls, xlsx, txt, doc, docx, ico, ppt, pptx, ods, wpd, rtf</b>
            </span>
}
          </label>
          <div>
            <div class="well well-xs pull-left" style="margin-right:5px;">
              <div class="btn btn-default btn-xs btn-white" title="Attach document">
                <i class="fa fa-paperclip"></i>
              </div>
            </div>
            <div style="width:92%" class="well well-xs pull-left">
              @for (file of attachmentTO.attachmented_files; track $index) {
<div class="btn-group btn-group-xs" role="group">
                <div class="btn btn-xs btn-default">
                  <i class="fa fa-paperclip"></i>
                </div>
                <div class="btn btn-default btn-xs btn-white" title="Download Attachment">{{file}}</div>
                <div class="btn btn-danger btn-xs" title="Remove attachment">
                  <i class="fa fa-times"></i>
                </div>
              </div>
}
            </div>
          </div>
        </div>
      </div>
}
    </form>
  </div>

  <!-- Modal Footer -->
  <div class="modal-footer" [hidden]="minimise">
    <button class="save-button" 
            type="button" 
            [disabled]="isSaveClicked" 
            (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
    </button>
    <button class="reset-button" 
            type="button" 
            (click)="reset()">Reset Form</button>
    <button class="cancel-button" 
            type="button" 
            (click)="cancel()">Cancel</button>
  </div>

}

<!-- ==================== POST 901 ADJUSTMENT VIEW ==================== -->
@if (viewType === 'postAdj') {

  <!-- Modal Header -->
  <div class="modal-header">
    <h3 class="modal-title">Post 901m Adjustment</h3>
    <div class="header-actions">
      <i class="fa" 
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
         style="margin-right: 10px; cursor: pointer;" 
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <!-- Modal Body -->
  <div class="modal-body" [hidden]="minimise">
    <!-- Key info (jak w code-combinations) -->
    <div style="margin-left:30px; margin-right:30px">
      <div class="code-combo-box-key">
        <span class="pull-left"><i class="fa fa-shield fa-lg"></i>&nbsp;</span>
        @if (codeCombinationSelected) {
<span>
          <b>Key: </b> 
          {{codeCombinationSelected.LEID}} - {{codeCombinationSelected.CDR_NO}} - {{codeCombinationSelected.REPORTING_PERIOD}} - {{codeCombinationSelected.ME_CODE}} - {{codeCombinationSelected.LEDGER}} - {{codeCombinationSelected.CURR}} - {{codeCombinationSelected.CHART_CODE}}
        </span>
}
        @if (!codeCombinationSelected && !showFormLoader) {
<span>
          <b>Key: </b> 
          {{rowData.LEID}} - {{rowData.CDR_NO}} - {{rowData.REPORTING_PERIOD}} - {{rowData.ME_CODE}} - {{rowData.LEDGER}} - {{rowData.CURR || rowData.FUNC_CURR}} - {{rowData.CHART_CODE}}
        </span>
}
        @if (showFormLoader) {
<span>
          <i class="fa fa-spinner fa-pulse"></i> Loading...
        </span>
}
      </div>
    </div>

    <form name="post901Adjustment" novalidate autocomplete="off">
      <div class="row form-group">
        <div class="col-md-6">
          <div class="row">
            <button id="post_901_adj" 
                    class="btn btn-info btn-sm post-adj-button" 
                    type="button" 
                    [disabled]="crudLoading"
                    (click)="post901Adjs()">
              @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
              Post 901m Adjustments
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

}
